import { useContext, useState } from 'react';
import { LoginContext } from '../../contexts/LoginContext';
import { firstDayMonth, todayDate, todayLastYear, YMD_FORMAT } from '../../utils/DateUtils';
import { AppContext } from '../../contexts/AppContext';
import { PaymentOrdersAPI } from '../../services/PaymentOrdersAPI';
import moment from 'moment';

const usePaymentOrdersPresenter = tableRef => {
  const { isSupplier, idSupplier } = useContext(LoginContext);
  const { showError, showWarning } = useContext(AppContext);

  const [firstLoad, setFirstLoad] = useState(true);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [dateFrom, setDateFrom] = useState(isSupplier ? firstDayMonth() : null);
  const [dateTo, setDateTo] = useState(isSupplier ? moment() : null);
  const [triggerNewSearch, setTriggerNewSearch] = useState(true);
  const [oldSearchRequest, setOldSearchRequest] = useState({});

  const cleanFilters = () => {
    setSelectedSupplier(null);
    setDateFrom(null);
    setDateTo(null);
  };

  const search = (page, pageSize) => {
    const request = triggerNewSearch
      ? {
          Cuit: isSupplier ? idSupplier : selectedSupplier.cuit,
          StartDate: dateFrom ? dateFrom.format(YMD_FORMAT) : todayLastYear(),
          EndDate: dateTo ? dateTo.format(YMD_FORMAT) : todayDate(),
          PageNumber: page,
          PageSize: pageSize,
        }
      : {
          ...oldSearchRequest,
          PageNumber: page,
          PageSize: pageSize,
        };

    return PaymentOrdersAPI.getPaymentOrders(request)
      .then(res => res)
      .catch(error => {
        const errorMsg = 'Error al obtener las ordenes de compra';
        showError(errorMsg, error);
        throw new Error(errorMsg);
      })
      .finally(() => {
        if (triggerNewSearch) {
          setOldSearchRequest(request);
          setTriggerNewSearch(false);
        }
      });
  };

  const validateFilters = () => {
    let errors = [];
    const errorMessages = [];
    let i = 0;

    if ((errors[i++] = !isSupplier && !selectedSupplier)) {
      errorMessages.push('Debe seleccionar un proveedor para iniciar la búsqueda');
    }

    if ((errors[i++] = dateFrom && !dateTo)) {
      errorMessages.push('Debe completar el rango de fechas o quitar la Fecha desde');
    }

    if ((errors[i++] = !dateFrom && dateTo)) {
      errorMessages.push('Debe completar el rango de fechas o quitar la Fecha hasta');
    }

    const hasErrors = errors.some(e => e);

    hasErrors && showWarning(errorMessages);

    return !hasErrors;
  };

  const validateAndSearch = () => {
    if (validateFilters()) {
      if (firstLoad) {
        setFirstLoad(false);
      } else {
        setTriggerNewSearch(true);
        tableRef.current.onChangePage(null, 0);
      }
    }
  };

  const rows = query =>
    new Promise((resolve, reject) => {
      search(query.page + 1, query.pageSize)
        .then(result =>
          resolve({
            data: result.data,
            page: query.page,
            totalCount: result.totalCount,
          })
        )
        .catch(error => reject(error));
    });

  return {
    selectedSupplier,
    setSelectedSupplier,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    validateAndSearch,
    cleanFilters,
    rows,
    firstLoad,
  };
};

export default usePaymentOrdersPresenter;
